import React from 'react'
import styled, { css } from 'styled-components'
import { brand, gray } from 'sutra/tokens/colors'

export type LogoTone = 'primary' | 'onDark' | 'onNavy' | 'watermark'
export type LogoMarkTone = 'primary' | 'onDark' | 'navy' | 'muted'

// Lockup geometry: 356×123 viewBox. Wordmark is 4 paths, mark is 3 paths —
// both extracted from the brand-approved SVGs (identical across tones; only
// fill differs).
const WORDMARK_PATHS = [
  'M143.623 94.8955L116.11 29.6668H133.021L151.541 77.9836H146.573L166.169 29.6668H183.081L153.284 94.8955H143.619H143.623ZM124.698 121.198L144.695 79.8617L153.284 94.8955L141.475 121.202H124.698V121.198Z',
  'M218.107 95.5665C211.844 95.5665 206.163 94.0706 201.06 91.0694C195.962 88.0729 191.889 84.0232 188.846 78.925C185.803 73.8267 184.284 68.0994 184.284 61.7475C184.284 55.3957 185.803 49.9805 188.846 44.9708C191.889 39.9611 195.957 35.9347 201.06 32.8916C206.159 29.8532 211.839 28.3293 218.107 28.3293C224.375 28.3293 230.34 29.8299 235.49 32.8264C240.635 35.8229 244.726 39.8539 247.769 44.9056C250.808 49.9619 252.332 55.5774 252.332 61.7475C252.332 67.9176 250.808 73.8267 247.769 78.925C244.726 84.0232 240.635 88.0729 235.49 91.0694C230.345 94.0659 224.552 95.5665 218.107 95.5665ZM218.107 80.9335C221.775 80.9335 224.995 80.1273 227.772 78.5195C230.545 76.9071 232.694 74.6516 234.213 71.7436C235.732 68.8357 236.496 65.5036 236.496 61.7429C236.496 57.9821 235.713 54.9669 234.148 52.1475C232.582 49.3281 230.433 47.0959 227.707 45.4369C224.976 43.7825 221.779 42.953 218.112 42.953C214.444 42.953 211.513 43.7825 208.782 45.4369C206.051 47.0959 203.903 49.3281 202.342 52.1475C200.776 54.9669 199.993 58.1685 199.993 61.7429C199.993 65.499 200.776 68.8357 202.342 71.7436C203.908 74.6516 206.051 76.9118 208.782 78.5195C211.508 80.132 214.621 80.9335 218.112 80.9335H218.107Z',
  'M290.983 92.7471C285.256 92.7471 280.088 91.363 275.484 88.5856C270.875 85.8127 267.249 81.9634 264.611 77.0423C261.969 72.1211 260.65 66.6221 260.65 60.5359C260.65 54.4497 261.969 48.9926 264.611 44.16C267.249 39.3273 270.875 35.4827 275.484 32.6167C280.092 29.7553 285.256 28.32 290.983 28.32C296.082 28.32 300.532 29.3499 304.339 31.405C308.142 33.4648 311.139 36.2609 313.334 39.7934C315.524 43.3304 316.577 47.4687 316.489 52.2081V68.9848C316.577 73.5471 315.501 77.6621 313.268 81.3343C311.031 85.0065 308.012 87.8213 304.209 89.7879C300.406 91.7591 295.998 92.7424 290.988 92.7424L290.983 92.7471ZM291.654 122.54C284.944 122.54 279.016 121.309 273.871 118.849C268.726 116.388 264.588 112.921 261.456 108.447L271.387 98.5164C273.983 101.648 276.91 104.02 280.176 105.628C283.443 107.24 287.358 108.042 291.92 108.042C297.647 108.042 302.21 106.565 305.612 103.615C309.009 100.66 310.71 96.5871 310.71 91.4003V75.565L313.259 61.3374L310.71 46.9747V29.6621H326.009V91.4003C326.009 97.6636 324.555 103.121 321.647 107.776C318.739 112.427 314.713 116.053 309.568 118.648C304.423 121.244 298.449 122.54 291.65 122.54H291.654ZM294.073 78.3844C297.563 78.3844 300.649 77.6481 303.333 76.1708C306.017 74.6935 308.049 72.6384 309.438 69.9961C310.822 67.3584 311.516 64.25 311.516 60.6664C311.516 57.0827 310.822 53.9557 309.438 51.2714C308.049 48.5871 306.017 46.4854 303.333 44.9615C300.649 43.4423 297.563 42.678 294.073 42.678C290.583 42.678 287.516 43.4376 284.878 44.9615C282.236 46.4854 280.158 48.5871 278.638 51.2714C277.115 53.9557 276.355 57.0873 276.355 60.6664C276.355 64.2454 277.115 67.2419 278.638 69.9261C280.158 72.6104 282.264 74.6889 284.948 76.1661C287.633 77.6434 290.671 78.3797 294.073 78.3797V78.3844Z',
  'M346.416 18.2586C343.909 18.2586 341.807 17.3872 340.106 15.6396C338.405 13.8967 337.557 11.6784 337.557 8.99417C337.557 6.49165 338.405 4.36194 340.106 2.61903C341.803 0.876116 343.909 0 346.416 0C349.101 0 351.268 0.871456 352.927 2.61903C354.581 4.36194 355.41 6.49165 355.41 8.99417C355.41 11.6784 354.581 13.892 352.927 15.6396C351.272 17.3825 349.101 18.2586 346.416 18.2586ZM338.764 94.2244V29.6668H354.199V94.2244H338.764Z',
]

const LOCKUP_MARK_PATHS = [
  'M15.2911 29.8112H39.0301L46.6495 16.6182C48.0289 14.2276 51.4868 14.2276 52.8662 16.6182L60.4856 29.8112H84.2246C88.0786 29.8112 89.4487 34.9141 86.1074 36.8435L49.7579 57.8283L13.4084 36.8435C10.0717 34.9141 11.4371 29.8112 15.2911 29.8112Z',
  'M34.9944 115.074L23.1249 94.518H7.88606C5.12257 94.518 3.3983 91.5261 4.77771 89.1355L12.3971 75.9425L0.52762 55.3817C-1.4017 52.045 2.33577 48.3075 5.67247 50.2369L42.0219 71.2217V113.191C42.0219 117.045 36.919 118.415 34.9897 115.074H34.9944Z',
  'M98.9835 55.3817L87.1139 75.9378L94.7334 89.1308C96.1128 91.5215 94.3885 94.5133 91.625 94.5133H76.3909L64.5213 115.069C62.592 118.406 57.4891 117.041 57.4891 113.187V71.217L93.8386 50.2322C97.1753 48.3029 100.913 52.0403 98.9835 55.377V55.3817Z',
]

// Standalone mark geometry: 176×181 viewBox, a single combined path.
const MARK_PATH =
  'M26.9504 26.4143H68.8005L82.2383 3.16182C84.6755 -1.05394 90.7576 -1.05394 93.1948 3.16182L106.633 26.4143H148.483C155.267 26.4143 157.683 35.4167 151.798 38.7981L87.7275 75.7958L23.6349 38.8201C17.7504 35.4167 20.1657 26.4363 26.9504 26.4363V26.4143ZM74.0922 173.417V99.4215L9.99955 62.4239C4.11506 59.0206 -2.47206 65.6077 0.931287 71.4922L21.8564 107.743L8.41864 130.996C5.98141 135.212 9.03344 140.481 13.9079 140.481H40.7614L61.6865 176.732C65.0898 182.617 74.0702 180.202 74.0702 173.417H74.0922ZM165.412 62.4239L101.341 99.4215V173.417C101.341 180.202 110.343 182.617 113.725 176.732L134.65 140.481H161.503C166.378 140.481 169.408 135.212 166.992 130.996L153.555 107.743L174.48 71.4922C177.883 65.6077 171.296 59.0206 165.412 62.4239Z'

const LOCKUP_VIEWBOX = '0 0 356 123'
const LOCKUP_RATIO = 356 / 123
const MARK_VIEWBOX = '0 0 176 181'
const MARK_RATIO = 176 / 181

interface ToneColors {
  wordmark: string
  mark: string
  opacity?: number
}

const logoToneStyles: Record<LogoTone, ToneColors> = {
  primary: { wordmark: brand.stillNight[800], mark: brand.sunriseCoral[500] },
  onDark: { wordmark: brand.white, mark: brand.white },
  onNavy: { wordmark: brand.white, mark: brand.sunriseCoral[500] },
  watermark: {
    wordmark: brand.stillNight[800],
    mark: brand.stillNight[800],
    opacity: 0.23,
  },
}

const markToneStyles: Record<LogoMarkTone, string> = {
  primary: brand.sunriseCoral[500],
  onDark: brand.white,
  navy: brand.stillNight[800],
  muted: gray[400],
}

const svgToneCss = ({
  wordmark,
  mark,
  opacity,
}: ToneColors): ReturnType<typeof css> => css`
  opacity: ${opacity ?? 1};

  .yogi-logo-wordmark {
    fill: ${wordmark};
  }

  .yogi-logo-mark {
    fill: ${mark};
  }
`

const LogoSvg = styled.svg<{ $tone: LogoTone }>`
  ${({ $tone }) => svgToneCss(logoToneStyles[$tone])}
`

const LogoMarkSvg = styled.svg<{ $tone: LogoMarkTone }>`
  fill: ${({ $tone }) => markToneStyles[$tone]};
`

export interface LogoProps {
  $tone?: LogoTone
  $height?: number
  title?: string
  className?: string
}

export const Logo = ({
  $tone = 'primary',
  $height = 32,
  title = 'Yogi',
  className,
}: LogoProps): React.ReactElement => (
  <LogoSvg
    $tone={$tone}
    height={$height}
    width={$height * LOCKUP_RATIO}
    viewBox={LOCKUP_VIEWBOX}
    xmlns="http://www.w3.org/2000/svg"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    className={className}
  >
    {title ? <title>{title}</title> : null}
    {WORDMARK_PATHS.map((d) => (
      <path key={d} className="yogi-logo-wordmark" d={d} />
    ))}
    {LOCKUP_MARK_PATHS.map((d) => (
      <path key={d} className="yogi-logo-mark" d={d} />
    ))}
  </LogoSvg>
)

Logo.displayName = 'Logo'

export interface LogoMarkProps {
  $tone?: LogoMarkTone
  $size?: number
  title?: string
  className?: string
}

export const LogoMark = ({
  $tone = 'primary',
  $size = 24,
  title,
  className,
}: LogoMarkProps): React.ReactElement => (
  <LogoMarkSvg
    $tone={$tone}
    height={$size}
    width={$size * MARK_RATIO}
    viewBox={MARK_VIEWBOX}
    xmlns="http://www.w3.org/2000/svg"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    className={className}
  >
    {title ? <title>{title}</title> : null}
    <path d={MARK_PATH} />
  </LogoMarkSvg>
)

LogoMark.displayName = 'LogoMark'
